var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPerfil = function SvgPerfil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8BA4A1",
    transform: "translate(-22 -576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 C8.1,0 0,8.1 0,18 C0,27.9 8.1,36 18,36 C27.9,36 36,27.9 36,18 C36,8.1 27.9,0 18,0 M18,5.4 C21.06,5.4 23.4,7.74 23.4,10.8 C23.4,13.86 21.06,16.2 18,16.2 C14.94,16.2 12.6,13.86 12.6,10.8 C12.6,7.74 14.94,5.4 18,5.4 M18,30.96 C13.5,30.96 9.54,28.62 7.2,25.2 C7.2,21.6 14.4,19.62 18,19.62 C21.6,19.62 28.8,21.6 28.8,25.2 C26.46,28.62 22.5,30.96 18,30.96",
    transform: "translate(22 576)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerfil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perfil.d81d5726.svg";
export { ForwardRef as ReactComponent };